import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { DirectivesModule } from './../../../directives/directives.module';
// import { PaymentMethodCardComponent } from './payment-method-card/payment-method-card.component';
// import { PaymentMethodMultibankComponent } from './payment-method-multibank/payment-method-multibank.component';
// import { PaymentMethodMBWayComponent } from './payment-method-mb-way/payment-method-mb-way.component';
// import { PaymentComponent } from './payment.component';
// import { PaymentMethodAlipayComponent } from './payment-method-alipay/payment-method-alipay.component';
// import { PaymentMethodIdealComponent } from './payment-method-ideal/payment-method-ideal.component';
// import { PaymentMethodBankTransferComponent } from './payment-method-bank-transfer/payment-method-bank-transfer.component';
import { ScreenService } from '@ibe.services/screen.service';
// import { PaymentMethodBankTransferBrComponent } from './payment-method-bank-transfer-br/payment-method-bank-transfer-br.component';
// import { PaymentMethodMulticaixaComponent } from './payment-method-multicaixa/payment-method-multicaixa.component';

import { INDRAPaymentMethodCardComponent } from './payment-method-card/payment-method-card.indra.component';
import { INDRAPaymentComponent } from './payment.indra.component';
import { INDRAPaymentMethodBancontactComponent } from './payment-method-bancontact/payment-method-bancontact.indra.component';
import { INDRAPaymentMethodPaypalComponent } from './payment-method-paypal/payment-method-paypal.indra.component';
import { INDRAPaypalPaymentComponent } from './paypal-payment/paypal-payment.component';
import { INDRAPaymentMethodMBWayComponent } from './payment-method-mb-way/payment-method-mb-way.indra.component';
import { INDRAPaymentMethodMultibankComponent } from './payment-method-multibank/payment-method-multibank.indra.component';
import { INDRAPaymentMethodAlipayComponent } from './payment-method-alipay/payment-method-alipay.indra.component';
import { INDRAPaymentMethodPoliComponent } from './payment-method-poli/payment-method-poli.indra.component';
import { INDRAPaymentMethodIdealComponent } from './payment-method-ideal/payment-method-ideal.indra.component';
import { INDRAPaymentMethodBankTransferComponent } from './payment-method-bank-transfer/payment-method-bank-transfer.indra.component';
import { INDRAPaymentMethodBankTransferBrComponent } from './payment-method-bank-transfer-br/payment-method-bank-transfer-br.indra.component';
import { INDRAPaymentMethodMulticaixaComponent } from './payment-method-multicaixa/payment-method-multicaixa.indra.component';
import { INDRAPaymentMethodPickupComponent } from './payment-method-pickup/payment-method-pickup.indra.component';
import { INDRAPaymentMethodLoteriasComponent } from './payment-method-loterias/payment-method-loterias.indra.component';
import { INDRACardlessComponent } from './cardless/cardless.indra.component';
import { INDRAPaymentMethodKlarnaComponent } from './payment-method-klarna/payment-method-klarna.indra.component';
import { INDRAPaymentMethodKlarnaPayLaterComponent } from './payment-method-klarna-pay-later/payment-method-klarna-pay-later.indra.component';

@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		FormsModule,
		ReactiveFormsModule,
		DirectivesModule
	],
	declarations: [
		// PaymentComponent,
		INDRAPaymentComponent,
		// PaymentMethodCardComponent,
		INDRAPaymentMethodCardComponent,
		// PaymentMethodMultibankComponent,
		INDRAPaymentMethodMultibankComponent,
		// PaymentMethodMBWayComponent,
		INDRAPaymentMethodMBWayComponent,
		// PaymentMethodPaypalComponent,
		INDRAPaymentMethodPaypalComponent,
		// PaymentMethodBankTransferComponent,
		// PaymentMethodAlipayComponent,
		INDRAPaymentMethodAlipayComponent,
		INDRAPaymentMethodPoliComponent,
		// PaymentMethodIdealComponent,
		INDRAPaymentMethodIdealComponent,
		// PaymentMethodBankTransferBrComponent,
		// PaymentMethodMulticaixaComponent,
		INDRAPaymentMethodBancontactComponent,
		INDRAPaypalPaymentComponent,
		INDRAPaymentMethodBankTransferComponent,
		INDRAPaymentMethodBankTransferBrComponent,
		INDRAPaymentMethodMulticaixaComponent,
		INDRAPaymentMethodPickupComponent,
		INDRAPaymentMethodLoteriasComponent,
		INDRACardlessComponent,
		INDRAPaymentMethodKlarnaComponent,
		INDRAPaymentMethodKlarnaPayLaterComponent,
	],
	exports: [
		// PaymentComponent,
		INDRAPaymentComponent,
		// PaymentMethodCardComponent,
		INDRAPaymentMethodCardComponent,
		// PaymentMethodMultibankComponent,
		INDRAPaymentMethodMultibankComponent,
		// PaymentMethodMBWayComponent,
		INDRAPaymentMethodMBWayComponent,
		// PaymentMethodBankTransferComponent,
		// PaymentMethodPaypalComponent,
		INDRAPaymentMethodPaypalComponent,
		// PaymentMethodAlipayComponent,
		INDRAPaymentMethodAlipayComponent,
		INDRAPaymentMethodPoliComponent,
		INDRAPaymentMethodIdealComponent,
		INDRAPaymentMethodBancontactComponent,
		INDRAPaypalPaymentComponent,
		INDRAPaymentMethodBankTransferComponent,
		INDRAPaymentMethodMulticaixaComponent,
		INDRAPaymentMethodPickupComponent,
		INDRACardlessComponent,
		INDRAPaymentMethodKlarnaComponent,
	],
	providers: [ScreenService]
})
export class PaymentModule { }
